module.exports = __webpack_public_path__ + "img/parche__corregido_ES.5fc0aaab.png";